// src/services/productService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL; // Using your .env for API URL
const getToken = () => {
    return localStorage.getItem('token');
  };
  const token = getToken();

export const getProducts = async () => {
  return await axios.get(`${API_URL}/products`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
};

export const getProductById = async (id) => {
  return await axios.get(`${API_URL}/products/${id}`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
};

export const createProduct = async (product) => {
  console.log(product);
  return await axios.post(`${API_URL}/products`, product, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
};

export const updateProduct = async (id, product) => {
  return await axios.put(`${API_URL}/products/${id}`, product, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
};

export const deleteProduct = async (id) => {
  return await axios.delete(`${API_URL}/products/${id}`, {
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
};
